export enum PhaseNames {
  drafting = 8,
  filing = 0,
  exam = 2,
  prosecution = 3,
  grant = 25,
  oneSixOneOneSixTwo = 6,
  appeal = 11,
  annuity = 14,
  ids = 9,
  publication = 4,
  postGrantReview = 13,
  validation = 5,
  pph = 10,
  noveltySearch = 7,
  idsCopies = 23,
  subsequentApplications = 24,
  misc = 22  
}
